export const test = {
  site: {
    baseName: ''
  }
};

export default test;
